module.exports = __webpack_public_path__ + "2e27dda75302f898feff96e4be159287.jpg";


//////////////////
// WEBPACK FOOTER
// ./apps/www.dawnofwar.com/src/static/img/gabriel-panel-1024.jpg
// module id = 332
// module chunks = 0